var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M7.56148852,8 C8.79518537,10.3613331 10.2706235,11.5 12,11.5 L12,10 L16,12 L12,14 L12,12.5 C10.0106739,12.5 8.34078706,11.3274608 7,9.04891166 C5.65921294,11.3274608 3.98932612,12.5 2,12.5 L0,12.5 L0,11.5 L2,11.5 C3.72937654,11.5 5.20481463,10.3613331 6.43851148,8 C5.20481463,5.63866689 3.72937654,4.5 2,4.5 L1.77635684e-15,4.5 L1.77635684e-15,3.5 L2,3.5 C3.98932612,3.5 5.65921294,4.67253924 7,6.95108834 C8.34078706,4.67253924 10.0106739,3.5 12,3.5 L12,2 L16,4 L12,6 L12,4.5 C10.2706235,4.5 8.79518537,5.63866689 7.56148852,8 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/Shuffle.78766ad6.svg";
export { ForwardRef as ReactComponent };